/**
 * Accetta un invito con un account gia' esistente (Andrea 2026-10-08):
 * nato per la cessione della squadra. Arriva qui chi apre il link
 * dell'invito ed e' gia' registrato (dal form di registrazione o dal login).
 * Chiama /auth/inviti/accetta e porta nella lega giusta.
 */

import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../../lib/api";
import { useCambiaLega } from "../../hooks/useLeghe";
import { LogoApp } from "../common/LogoApp";
import { tr } from "../../i18n";

interface Esito {
  tipo_invito: string;
  lega_id: string;
  squadra_id: string | null;
  nome_squadra: string | null;
}

export function AccettaInvitoPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const codice = params.get("codice");
  const cambiaLega = useCambiaLega();
  const [errore, setErrore] = useState<string | null>(null);
  const [esito, setEsito] = useState<Esito | null>(null);
  const avviato = useRef(false);

  useEffect(() => {
    if (avviato.current) return;
    avviato.current = true;
    if (!token && !codice) {
      setErrore(tr("Manca il codice dell'invito."));
      return;
    }
    api
      .post<Esito>("/auth/inviti/accetta", { token, codice })
      .then((r) => setEsito(r.data))
      .catch((e) => {
        const err = e as { response?: { data?: { detail?: string } }; message?: string };
        setErrore(err.response?.data?.detail ?? err.message ?? tr("Invito non valido"));
      });
  }, [token, codice]);

  const testo = esito
    ? esito.tipo_invito === "cessione_squadra"
      ? tr("Da adesso {{v1}} è tua: rosa, budget e risultati compresi.", {
          v1: esito.nome_squadra ?? "la squadra",
        })
      : esito.tipo_invito === "allenatore_secondo"
        ? tr("Sei allenatore in seconda di {{v1}}.", { v1: esito.nome_squadra ?? "una squadra" })
        : tr("Invito accettato.")
    : null;

  return (
    <div className="min-h-screen bg-bg text-fg flex items-center justify-center p-6">
      <div className="card max-w-md w-full space-y-4 text-center">
        <LogoApp className="w-16 h-16 mx-auto" />
        {!esito && !errore && (
          <div className="text-sm text-fg-muted">{tr("Accetto l'invito…")}</div>
        )}
        {errore && (
          <>
            <div className="font-display text-xl text-danger">{tr("Invito non valido")}</div>
            <p className="text-sm text-fg-muted">{errore}</p>
            <Link to="/" className="btn-ghost w-full">
              {tr("Torna alla Home")}
            </Link>
          </>
        )}
        {esito && (
          <>
            <div className="font-display text-xl text-accent">{tr("Fatto! 🎉")}</div>
            <p className="text-sm text-fg">{testo}</p>
            <button
              type="button"
              className="btn-primary w-full"
              onClick={() => void cambiaLega(esito.lega_id, esito.squadra_id ? "/rosa" : "/")}
            >
              {esito.squadra_id ? tr("Vai alla tua squadra") : tr("Entra nella lega")}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
